import './_RemoveTokenButton-c205593b.css';

var classes = {"TokenButton":"prc-Token-TokenButton-F4Y8h"};

export { classes as default };
